import { gql } from '@apollo/client';

export const UPDATE_RENDERER = gql`   
 mutation MyMutation($payload: CommandInput!) {
     updateRenderer(payload: $payload) {      
       renderer        
       layer    }}`;

export const UPDATE_INITIAL_COMMAND = gql`  
         mutation MyMutation($payload: InitialCommandInput!) { 
            updateInitialState(payload: $payload) {   
                 eventId    }}`;

// export const CLEAR_COMMAND = gql`  
//   mutation MyMutation($payload: CommandInput!) {
//      updateRenderer(payload: $payload) {      
//        renderer        
//        layer    }}`;        

export const RESET_RENDERER = gql`mutation ResetRenderer($rendererId: String, $reset: Boolean) {
    resetRenderer(payload: { rendererId: $rendererId, reset: $reset }) {
        rendererId
        reset
    }
}
`;